// image_info ({ host_url, path, query, provider }) から表示用のURL文字列を組み立てるユーティリティ。
//
// provider ごとの組み立ては Nuxt 側 buildImageUrl（nuxt3/utils/image.ts）と揃える。
// 本ユーティリティは legacy webpack の Vue から options なしで呼ばれるため、
// 変換オプションは受け取らず provider 判定のみを行う。
//
// - imgix    → host_url + path（変換クエリは付与しない）
// - imgproxy → `{host_url}/_/preset:default/plain{path}`（default preset を明示）
// - plain    → host_url + path (+ query)（変換なしの素のホスト配信）
//
// path は仕様上 "/" 始まりだが、入力源によっては欠ける可能性があるため内部で正規化する。
export default function imageInfoUrl(imageInfo) {
  if (!imageInfo || !imageInfo.host_url || !imageInfo.path) {
    return null;
  }

  const normalizedPath = imageInfo.path.startsWith('/') ? imageInfo.path : `/${imageInfo.path}`;

  switch (imageInfo.provider) {
    case 'imgproxy':
      return `${imageInfo.host_url}/_/preset:default/plain${normalizedPath}`;
    case 'plain': {
      const qs = imageInfo.query ? `?${imageInfo.query}` : '';
      return `${imageInfo.host_url}${normalizedPath}${qs}`;
    }
    case 'imgix':
    default:
      return `${imageInfo.host_url}${normalizedPath}`;
  }
}
